import { ReactNode } from 'react';
import { DndProvider, useDragLayer, XYCoord } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { InteractiveDragLayerContainer } from './interactive-drag-layer.style';

export const InteractiveDragDrop = ({ children }: { children: ReactNode }) => {
  const isTouch = 'ontouchstart' in document.documentElement;
  return (
    <DndProvider backend={isTouch ? TouchBackend : HTML5Backend}>
      {children}
      <InteractiveDragLayer />
    </DndProvider>
  );
};

function getItemStyles(
  initialOffset: XYCoord | null,
  currentOffset: XYCoord | null
) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

export const InteractiveDragLayer = () => {
  const { isDragging, item, initialOffset, currentOffset } = useDragLayer(
    monitor => ({
      item: monitor.getItem(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    })
  );

  return (
    <InteractiveDragLayerContainer $isDragging={isDragging}>
      {isDragging && item.el && (
        <div
          style={{
            ...getItemStyles(initialOffset, currentOffset),
            height: '100%',
          }}
          dangerouslySetInnerHTML={{ __html: item.el.innerHTML }}
        />
      )}
    </InteractiveDragLayerContainer>
  );
};

export default InteractiveDragDrop;
